import { Card, CardContent, CardHeader, Grid, Box } from "@mui/material";
import React from "react";
import Button from "@mui/material/Button";
import SendMyTRNForm from "./SendMyTRNForm";
import {
  searchResultsTRN,
  cancelVerification,
  setPageReg,
} from "../../features/trnAppSlice";
import { useSelector, useDispatch } from "react-redux";
import { PAGES } from "../../App";

export default function TRNSearchResultsForm() {
  const resultsTRN = useSelector(searchResultsTRN);
  const dispatch = useDispatch();

  const handleNavegistrationPage = () => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set("querytype", "pitregistration");

    url.search = params.toString();
    window.history.pushState({}, "", url.toString());

    dispatch(setPageReg());
  };

  return (
    <Grid size={{ xs: 12}}>
      <Card>
        {resultsTRN.notRegistered ? (
          <CardHeader title="Not Registered" />
        ) : (
          <CardHeader title="Thank You For Your Query" />
        )}
        <CardContent>
          <div style={{ fontFamily: "Arial, Helvetica", fontSize: "14px" }}>
            {resultsTRN.partyDataComments}
          </div>
          <Grid container columnSpacing={1.5} rowSpacing={0.5}>
            {
              resultsTRN.partyDataComments ===
                "Our records show that there is no Personal Income Tax Number linked to your ID Number. " +
                  "If you would like to register for Personal Income Tax, please click the REGISTER button. " +
                  "If you prefer to not register, please click the Cancel button." &&
              resultsTRN.IDType === 1 ? (
                // <RegisterForTaxNumberForm />
                <Box
                  style={{
                    marginTop: "2vh",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box>
                    <Button
                      type="button"
                      variant="outlined"
                      onClick={() =>
                        dispatch(
                          cancelVerification({
                            targetPage: PAGES.WhatsMyTaxNumberForm,
                          })
                        )
                      }
                      style={{ marginLeft: "2vh" }}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <Box>
                    <Button
                      type="button"
                      variant="contained"
                      onClick={handleNavegistrationPage}
                      style={{ marginLeft: "160vh" }}
                    >
                      Register
                    </Button>
                  </Box>
                </Box>
              ) : resultsTRN.partyDataComments ===
                "If you would like us to send your Tax Reference Number to you, please confirm your details below." ? (
                <SendMyTRNForm />
              ) : // ) : resultsTRN.partyDataComments ===
              //   "Unfortunately, the details that you supplied do not match to an active tax reference number. " +
              //   "Please visit www.sarsefiling.co.za or make an appointment to visit your nearest SARS Branch." ? (
              //   <Button
              //     style={{ marginTop: "4vh", marginLeft: "2vh" }}
              //     type="button"
              //     variant="contained"
              //     onClick={() => dispatch(cancelVerification())}
              //   >
              //     Close
              //   </Button>
              // )
              // : resultsTRN.partyDataComments ===
              //   "Inactive Personal Income Tax Number. Our records show that there is a Personal Income Tax Number linked to your ID Number, but that it is Inactive. " +
              //   "Please make an appointment to visit your nearest SARS Branch for assistance." ? (
              //   <Button
              //     style={{ marginTop: "4vh", marginLeft: "2vh" }}
              //     type="button"
              //     variant="contained"
              //     onClick={() => dispatch(cancelVerification())}
              //   >
              //     Close
              //   </Button>
              // )
              // : resultsTRN.partyDataComments ===
              //   "Unfortunately, your query cannot be processed as you have reached the weekly limit for tax reference number requests. " +
              //   "Please visit www.sarsefiling.co.za or make an apponitment to visit your nearest branch should you require additional assistance." ? (
              //   <Button
              //     style={{ marginTop: "4vh", marginLeft: "2vh" }}
              //     type="button"
              //     variant="contained"
              //     onClick={() => dispatch(cancelVerification())}
              //   >
              //     Close
              //   </Button>
              // )
              // : resultsTRN.partyDataComments ===
              //   "Unfortunately, we couldn't find an email address or cellphone number linked to your Tax Reference Number, therefore we are unable to process your request. " +
              //   "Please visit www.sarsefiling.co.za or make an appointment to visit your nearest SARS Branch." ? (
              //   <Button
              //     style={{ marginTop: "4vh", marginLeft: "2vh" }}
              //     type="button"
              //     variant="contained"
              //     onClick={() => dispatch(cancelVerification())}
              //   >
              //     Close
              //   </Button>
              //   )
              null
              //<Confirmation />
            }
          </Grid>
        </CardContent>
        <br />
      </Card>
    </Grid>
  );
}
